import { UI } from '@gik/ui-legacy/UIManager';

/**
 * Shows the "Remove Page?" confirmation dialog for unlinking an InKind Page
 * from a Group (the tile trash button in `InkindGroupCard`).
 * Returns `true` if the user confirmed, `false` if they cancelled.
 */
export async function confirmRemovePageFromGroup() {
  return UI.confirm(
    <>
      <p>Are you sure you want to remove this Inkind Page from your Group?</p>
    </>,
    {
      title: 'Confirm Removal',
      okButtonProps: {
        variant: 'danger',
      },
      okText: 'Remove',
    }
  );
}

/**
 * Shows the "Deactivate Group?" confirmation dialog (settings page footer
 * button in `GroupAdminLayout`).
 * Returns `true` if the user confirmed, `false` if they cancelled.
 */
export async function confirmDeactivateGroup() {
  return UI.confirm(
    <>
      <p>
        Are you sure you want to deactivate this Group? It will no longer be available to any visitors. Any InKind Page
        linked to your Group will be unlinked.
      </p>
    </>,
    {
      title: 'Deactivate Group?',
      okButtonProps: {
        variant: 'danger',
      },
      okText: 'Deactivate',
    }
  );
}
